import { useDraggable, useDroppable } from "@dnd-kit/core";
import classNames from "classnames";
import { useInView } from "react-intersection-observer";

import { DRAGGABLE_TYPES } from "../constants";
import DndIndicator from "../Indicator";

const DragDropContainer = ({
  id,
  index,
  data,
  render,
  isDragAndDropDisabled = false,
}) => {
  const {
    attributes,
    listeners,
    isDragging,
    setNodeRef: setDraggableNodeRef,
  } = useDraggable({
    data: { ...data, type: DRAGGABLE_TYPES.SECTION, index },
    id: `draggable-section--${id}`,
    disabled: isDragAndDropDisabled,
  });

  const { isOver, setNodeRef: setDroppableNodeRef } = useDroppable({
    data: { ...data, accepts: [DRAGGABLE_TYPES.SECTION], index: index + 1 },
    id: `droppable-section--${id}`,
  });

  const isIndicatorVisible = !isDragging && isOver;

  return (
    <div
      {...(!isDragAndDropDisabled && listeners)}
      {...(!isDragAndDropDisabled && attributes)}
      className={classNames("relative h-full w-full select-none flex-col", {
        "opacity-65": isDragging,
      })}
      ref={node => {
        setDraggableNodeRef(node);
        setDroppableNodeRef(node);
      }}
    >
      {render()}
      {isIndicatorVisible && <DndIndicator layout="vertical" />}
    </div>
  );
};

const SectionContainer = props => {
  const [setViewRef, inView] = useInView();

  return (
    <div
      className="neeto-molecules-boardview-section relative me-3 h-full last-of-type:me-0"
      ref={node => {
        setViewRef(node);
      }}
    >
      {inView && <DragDropContainer {...props} />}
    </div>
  );
};

export default SectionContainer;
